import _ from "lodash";
import {
  inject,
  computed,
  defineComponent,
  ref,
  PropType,
  reactive,
  toRefs,
  watch,
  onMounted,
  onActivated,
} from "vue";
import { message } from "ant-design-vue";
import { FilePageReq } from "@/core/services/biz-file.interface";
import FileStatus from "./file-status.vue";
import { FileUploadService, BizFileService } from "@/core";
import { generateUuid, getFileExt } from "@/utils";
import { FileRecord, UploadStatus } from "@/core/services/file-upload.interface";
import columns from "./upload-file-table-constant";
import { submitSuccessEmitter } from "@/utils/emitter";
import { useRoute } from "vue-router";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
interface IState {
  visible: boolean;
  fileList: FileRecord[];
}
export default defineComponent({
  isGlobal: true,
  name: "UploadFileTable",
  components: { FileStatus },
  props: {
    value: {
      type: Array as PropType<FileRecord[]>,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    uploadedCount: {
      type: Number,
      default: 0,
    },
    uploadButtonText: {
      type: String,
      default: "上传附件",
    },
    maxCount: {
      type: Number,
      default: 100,
    },
    maxSize: {
      type: Number,
      default: 100, // 100M
    },
    allowEdit: {
      type: Boolean,
      default: undefined,
    },
    bizType: {
      type: String,
      require: true,
    },
    uploadAccess: {
      type: String,
    },
    downloadAccess: {
      type: String,
    },
    deleteAccess: {
      type: String,
    },
    class: {
      type: String,
      default: "responsive-table",
    },
  },
  emits: ["ok", "update:value"],
  setup(props, { emit }) {
    // const parentState = (inject("parentState") || {}) as any;
    const route = useRoute();
    const { run } = BizFileService.useCreateApi();
    const { data: fileList, run: runFileList } = BizFileService.usePageApi();
    const uploading = ref(false);
    const state = reactive({
      tableRef: null,
      visible: false,
      fileList: [] as FileRecord[],
      id: computed(() => {
        return route.params.id;
      }),
    });

    const getFileList = async (bizId) => {
      const fileReq = new FilePageReq();
      fileReq.merge({
        bizId,
        bizType: props.bizType,
        current: 1,
        size: 100,
      });
      await runFileList(fileReq);
      state.fileList = fileList.value as any;
      state.fileList.forEach((o: any) => {
        if (!o.uid) {
          o.uid = generateUuid();
        }
      });
      // console.log(fileList,'fileListfileList');
      
      emit("update:value", state.fileList);
    };

    const maxSizeByte = computed(() => {
      return props.maxSize * 1024 * 1024;
    });

    const disabled = computed(() => {
      const rest = props.maxCount - props.uploadedCount;
      return rest <= 0;
    });

    const setFileStatus = (uid, status) => {
      state.fileList = state.fileList.map((item) => {
        if (item.uid === uid) {
          item.status = status;
        }
        return item;
      });
    };

    const setFileUrl = (uid, url) => {
      state.fileList = state.fileList.map((item) => {
        if (item.uid === uid) {
          item.url = url;
        }
        return item;
      });
    };

    const beforeUpload = (file) => {
      if (file.size > maxSizeByte.value) {
        message.warning(`单个文件不得超过${props.maxSize}M`);
        return false;
      }
      if (state.fileList?.length > 99) {
        message.warning(`附件上传限100个`);
        return false;
      }
      // return false;
    };

    const customRequest = async ({ file }) => {
      if (state.fileList?.length > 99) {
        message.warning(`附件上传限100个`);
        return false;
      }
      // console.log("file", file);

      const fileRecord = new FileRecord();
      fileRecord.merge({
        uid: file.uid,
        name: file.name,
        suffix: getFileExt(file.name),
        size: file.size,
        url: "",
        status: UploadStatus.UPLOADING,
      });
      state.fileList.push(fileRecord);
      const url = await FileUploadService.uploadToOss(file, uploading);
      if (url) {
        setFileUrl(file.uid, url);
        setFileStatus(file.uid, UploadStatus.SUCCESS);
        emit("update:value", state.fileList);
        // console.log("state.fileList", state.fileList);
        (state.tableRef as any).reloadData();
      } else {
        setFileStatus(file.uid, UploadStatus.FAIL);
      }
    };

    const deleteFile = (file: FileRecord) => {
      state.fileList = state.fileList.filter((item) => item.uid !== file.uid);
      emit("update:value", state.fileList);
    };

    watch(
      () => props.value,
      (newValue) => {
        if (newValue?.length) {
          newValue.forEach((file) => {
            file.status = UploadStatus.SUCCESS;
            if (!file.uid) {
              file.uid = generateUuid();
            }
          });
          if (newValue?.length) {
            state.fileList = newValue;
          }
        } else {
          state.fileList = [];
        }
      },
      { deep: true, immediate: true }
    );

    onMountedOrActivated(() => {
      state.fileList = [];
      // if (state.id) {
      //   getFileList(state.id);
      // }
      submitSuccessEmitter.off("submit-success");
      submitSuccessEmitter.on("submit-success", async (obj) => {
        state.fileList.forEach((item) => {
          item.bizId = obj.bizId;
          item.bizType = obj.bizType;
        });
        if (state.fileList?.length > 0) {
          await run(state.fileList, obj.bizId, obj.bizType);
        }
        state.fileList = [];
      });
    });

    return {
      ...toRefs(state),
      disabled,
      columns,
      beforeUpload,
      customRequest,
      deleteFile,
      uploading,
    };
  },
});
